<div class="flex w-full items-center">
    <div class=" flex items-center shrink-0 gap-2 w-32" (click)="onClick()">
        <div class="w-8 shrink-0">
            <vw-cultivation-item-viewer [cultivation]="cultivation" [displayType]="'TINY'"></vw-cultivation-item-viewer>
        </div>
        <div class="text-xs font-semibold text-primary-800 w-full text-ellipsis">
            {{name ?? cultivation.name}}</div>
        @if (type === 'hierarchy') {
        <div class="text-grey-200 w-4 flex items-center justify-center transition-transform duration-300"
            [ngClass]="{'rotate-90': isOpen, 'rotate-0': !isOpen}">
            <vw-chevron-right-icon></vw-chevron-right-icon>
        </div>
        }
    </div>
    <div class="flex flex-col gap-1 w-full ml-2 relative">
        <div class="absolute inset-0 grid grid-cols-12">
            @for (month of [1,2,3,4,5,6,7,8,9,10,11,12]; track month) {
            <div class="col-span-1 h-full w-full border-r border-grey-50" [ngClass]="{'border-l': month === 1}"></div>
            }
        </div>
        @if (showSeed) {
        <vw-calendar-period-line [periods]="seedPeriods" [type]="'SEEDLING'"></vw-calendar-period-line>
        }
        @if (showHarvest) {
        <vw-calendar-period-line [periods]="harvestPeriods" [type]="'HARVEST'"></vw-calendar-period-line>
        }
    </div>
</div>